import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

import { DataCollection } from '../../models/site-content/data-collection.model';
import { DataCollectionStatus } from '../../models/data-collection-status.model';
//import { ConfirmationDialogModel, ConfirmationDialogComponent } from '../../dialogs/confirmation/confirmation-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { AlertDialogComponent, AlertDialogModel } from '../../../shared/dialogs/alert/alert-dialog.component';

@Component({
    selector: 'app-site-workflow-status',
    templateUrl: './site-workflow-status.component.html',
    styleUrls: ['./site-workflow-status.component.scss'],
    standalone: false
})
export class SiteWorkflowStatusComponent implements OnInit {
    changeWorkflow: boolean;

    @Input() site: DataCollection;

    @Output() onSave: EventEmitter<DataCollection> = new EventEmitter();

    constructor(public dialog: MatDialog) { }

    ngOnInit() {
    }

    isSetup(): boolean {
        return this.site.currentStatus === DataCollectionStatus.SETUP;
    }

    isActive(): boolean {
        return this.site.currentStatus === DataCollectionStatus.ACTIVE;
    }

    isClosed(): boolean {
        return this.site.currentStatus === DataCollectionStatus.CLOSED;
    }
    setSetup(): void {
        this.setWorkflow('Setup');
    }
    setActive(): void {
        this.setWorkflow('Active');
    }
    setClosed(): void {
        this.setWorkflow('Closed');
    }

    setWorkflow(name: string) {
        let transitionName = `${this.site.currentStatus} to ${name}`;

        // 03-02-2023 change:  allow the user to transition from any workflow state to any state.
        //
        // Note:  this will require a change in the workflow definition or the server code that
        //        applies it.
        if (!this.site.isValidWorkflowTransition(transitionName)) {
            let message = `Please set the site status to 'Active' before setting it to '${name}'.`;
            let alertDlgModel = new AlertDialogModel('Cannot Directly Transition', message);
            this.dialog.open(AlertDialogComponent, {
                maxWidth: "600px",
                data: alertDlgModel
            });

            return;
        }            

        /*
        let dialogRef = this.dialog.open(ConfirmationDialogComponent, {
            data: new ConfirmationDialogModel("Site Status Change", `Are you sure you want to change the Site Status to ${name}?`)
        });
        dialogRef.afterClosed().subscribe(yes => {
            if (yes) {
                this.site.statuses.unshift({ status: name, createdDate: new Date() })
                this.site.selectedWorkflowTransition = transitionName;
                this.site.currentStatus = name;
                this.doUpdate(this.site);
            }
        });
        */
        this.site.statuses.unshift({ status: name, createdDate: new Date() })
        this.site.selectedWorkflowTransition = transitionName;
        this.site.currentStatus = name;
        this.doUpdate(this.site);
    }

    doUpdate(site) {
        this.site = site;
        this.onSave.emit(site);
    }

}
